<mat-list class="preview-list" [class.single-column]="singleColumn()">
  @for (preview of previews.value(); track preview.name) {
    <mat-list-item class="file-item" [class.error]="preview.error">
      @if (preview.src) {
        <img
          matListItemIcon
          class="file-img"
          [src]="preview.src"
          alt="Vorschau"
        />
      } @else {
        <div matListItemIcon class="file-icon-wrapper">
          <ui-icon [faName]="preview.icon" faStyle="light"></ui-icon>
        </div>
      }

      <span matListItemTitle>{{ preview.name }}</span>
      <span matListItemLine>{{ preview.name | fileFormat }}</span>

      @if (editable()) {
        <ui-icon-button
          (clicked)="remove.emit(preview.index)"
          buttonStyle="unthemed"
          icon="trash"
          iconStyle="light"
          matListItemMeta
        ></ui-icon-button>
      }
    </mat-list-item>
  }
</mat-list>
